import type { ChartArea } from 'chart.js';
import chroma from 'chroma-js';

import { LINE_CHART_OPTIONS } from './options';
import { IntervalFilter, TimespanFilter, TooltipLabelsType } from '../../types';

export const mapDurationToInterval = (selectedDuration) => {
  return {
    [TimespanFilter.OneMonth]: [IntervalFilter.Week],
    [TimespanFilter.ThreeMonth]: [
      IntervalFilter.Week,
      IntervalFilter.FourWeeks,
    ],
    [TimespanFilter.SixMonth]: [
      IntervalFilter.Week,
      IntervalFilter.FourWeeks,
      IntervalFilter.ThreeMonth,
    ],
    [TimespanFilter.OneYear]: [
      IntervalFilter.Week,
      IntervalFilter.FourWeeks,
      IntervalFilter.ThreeMonth,
      IntervalFilter.SixMonth,
    ],
  }[selectedDuration];
};

function createGradient(
  ctx: CanvasRenderingContext2D,
  area: ChartArea,
  themeColor: string,
) {
  const colorStart = chroma(themeColor).alpha(0.3);
  const colorMid = chroma(themeColor).alpha(0.2);
  const colorEnd = chroma(themeColor).alpha(0);

  // const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);
  const gradient = ctx.createLinearGradient(0, 230, 0, 50);

  gradient.addColorStop(1, colorStart);
  gradient.addColorStop(0.6, colorMid);
  gradient.addColorStop(0.4, chroma(themeColor).alpha(0.1));
  gradient.addColorStop(0.2, colorEnd);
  gradient.addColorStop(0, colorEnd);

  return gradient;
}

export function getHistoryChartData(
  labels,
  tooltips: TooltipLabelsType,
  datasets,
  colors: string[],
  newDataStartIndex: number,
  colorScale?: (value: number) => string, // Optional parameter
  showBackgroundGradient: boolean = true,
) {
  let chart1 = (canvas) => {
    let temp_datasets: any[] = [];

    for (let index = 0; index < datasets.length; index++) {
      let data_config = {
        ...LINE_CHART_OPTIONS,
        label: tooltips[index].label,
        data: datasets[index],
        fill: !colorScale && showBackgroundGradient,
        borderColor: colorScale ? undefined : colors[index],
        pointHoverBackgroundColor: colorScale
          ? datasets[index].map(colorScale)
          : colors[index],
        pointHoverBorderColor: colorScale
          ? datasets[index].map(colorScale)
          : colors[index],
        pointBorderColor: colorScale
          ? datasets[index].map(colorScale)
          : colors[index],
        pointBackgroundColor: 'white',
        backgroundColor:
          !colorScale && showBackgroundGradient
            ? function (context) {
                const chart = context.chart;
                const { ctx, chartArea } = chart;

                if (!chartArea) {
                  // This case happens on initial chart load
                  return null;
                }
                return createGradient(ctx, chartArea, colors[index]);
              }
            : undefined,
        segment: colorScale
          ? {
              borderColor: (ctx) => {
                if (!ctx.p1) return colors[index];
                return colorScale(ctx.p1.raw);
              },
            }
          : undefined,
      };

      temp_datasets.push(data_config);
    }

    return {
      labels: labels,
      datasets: temp_datasets,
    };
  };

  return chart1;
}
